/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { COLORS } from "./payments.constants";

export default function PaymentMethodCard({ payment, isArabic }) {
  const { img, nameAr, nameEn, descAr, descEn } = payment;

  return (
    <div className="col-md-4 col-lg-3">
      <div
        className="card h-100 text-center"
        style={{
          borderRadius: 18,
          padding: 25,
          background: "rgba(255,255,255,0.08)",
          border: "1.5px solid rgba(255,255,255,0.15)",
          color: COLORS.textLight,
          boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
          backdropFilter: "blur(6px)",
          transition: "all 0.35s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-6px)";
          e.currentTarget.style.boxShadow =
            "0 10px 24px rgba(242,180,65,0.3)";
          e.currentTarget.style.border = `1.5px solid ${COLORS.gold}`;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow =
            "0 8px 20px rgba(0,0,0,0.25)";
          e.currentTarget.style.border =
            "1.5px solid rgba(255,255,255,0.15)";
        }}
      >
        <img
          src={img}
          alt={isArabic ? nameAr : nameEn}
          style={{
            width: "110px",
            height: "65px",
            objectFit: "contain",
            margin: "0 auto 18px",
            filter: "drop-shadow(0 3px 8px rgba(0,0,0,0.2))",
          }}
        />

        <h6
          className="fw-bold mb-2"
          style={{
            color: COLORS.gold,
            fontSize: "1.1rem",
            fontFamily: "'Cairo', sans-serif",
          }}
        >
          {isArabic ? nameAr : nameEn}
        </h6>

        <p
          style={{
            fontSize: ".96rem",
            color: COLORS.textLight,
            opacity: 0.9,
            lineHeight: 1.6,
            maxWidth: 220,
            margin: "0 auto",
            fontFamily: "'Tajawal', sans-serif",
          }}
        >
          {isArabic ? descAr : descEn}
        </p>
      </div>
    </div>
  );
}
